<template>
  <ContentWithHeader>
    <template #header>
      <div class="d-flex justify-content-between align-items-center">
        <button
          class="btn no-bg"
          @click="setPosSection('choose-product')"
        >
          <i class="fas fa-chevron-left"/>
        </button>
        <div>
          <TotalPriceText class="total-price-text"/>
        </div>
      </div>
    </template>
    <template #content>
      <section class="payment-section">
        <div
          v-if="posSettings.payment.is_active"
          class="wrapper-payment-methods"
        >
          <div class="col no-padding mb-2 title">
            {{ $t('apps.pos.message.paymentmethod') }}:
          </div>
          <div>
            <div
              class="btn-group btn-group-payment-methods"
              role="group">
              <button
                v-for="(item, index) in paymentMethodsButtons"
                :key="index"
                :class="item.btnClass"
                type="button"
                @click="handleSelectPaymentMethod(item.name)"
              >
                {{ item.text }}
              </button>
            </div>
          </div>
        </div>
        <div class="wrapper-payment-form">
          <calculator-view
            v-if="paymentMethod === POS_PAYMENT_METHOD.CASH"
            :compare="true"
            :disabled="disabledBtnEnter"
            @submit="onSubmit"
          />
          <other-payment-form
            v-else
            :total="totalPrice"
            :paymentMethod="paymentMethod"
            :disabled="disabledBtnEnter"
            @submit="onSubmit"
          />
        </div>
      </section>
    </template>
  </ContentWithHeader>
</template>

<script>
import paymentMixin from '@/mixins/pos/payment'
import ContentWithHeader from '../common/ContentWithHeader.vue'
import TotalPriceText from '../common/TotalPriceText.vue'

export default {
  mixins: [paymentMixin],

  components: {
    ContentWithHeader,
    TotalPriceText,
  },
}
</script>

<style scoped>
  .orders-section, .payment-section {
    height: -webkit-calc(100% - 8px);
  	height:    -moz-calc(100% - 8px);
  	height:         calc(100% - 8px);

    padding: 20px 0;
  }
  .orders-section {
    width: 334px;
    float: left;
    margin-top: 8px;
    background: #fff;
    border: solid 1px #F2F2F2;
  }
  .payment-section {
    width: 100%;
    float: left;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
  }
  .payment-section .wrapper-payment-form {
    width: 90%;
    height: 500px;
  }

  .payment-section .wrapper-payment-methods {
    width: 90%;
  }

  .payment-section .wrapper-payment-methods .title {
    font-size: 14px;
  }

  .payment-section .wrapper-payment-methods .helper {
    font-size: 13px;
    color: #ccc;
  }

  .btn-group-payment-methods {
    display: flex;
    overflow-x: auto;
  }

  .btn-group-payment-methods .btn {
    flex: 1;
    font-size: 14px;
    box-shadow: none;
  }

  body[device="desktop"] .btn-group-payment-methods .btn {
    height: 50px;
  }

  @media (min-width: 1023px) {
    .payment-section .wrapper-payment-form {
      width: 600px;
      height: 500px;
    }

    .payment-section .wrapper-payment-methods {
      width: 600px;
    }
  }

  .wrapper-payment-form /deep/ .wrapper-other-payment-form .btn {
    font-size: 18px;
  }

  .total-price-text {
    color: #fff;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/include/Payment.vue